import { TextareaCounter } from "./textarea-counter.component";
import { TextareaCounterContainer } from "./textarea-counter-container.component";
import { TextareaContainer } from "./textarea-container.component";
export const components = {
  Container: TextareaContainer,
  CounterContainer: TextareaCounterContainer,
  Counter: TextareaCounter
};